import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type ProjectActionResponse =
  APIResponse<'/api/v4/projects/{projectId}/actions'>;

export const fetchProjectActionsInfo = async (projectId: string) =>
  get<ProjectActionResponse>(`/v4/projects/${projectId}/actions`);
